module.exports = __webpack_public_path__ + "static/tcdd-tasarim-9357edd68b40c86af1041e1ca2a5391a.png";